// QR Loyalty — supported venue currencies (owner picks one; symbol shown
// everywhere prices appear). Display symbol comes from the API responses
// (venue.currency_symbol / kitchen session), this list drives the picker.
export const LOYALTY_CURRENCIES = [
  { code: 'JOD', symbol: 'د.أ', flag: '🇯🇴', name: 'Jordanian Dinar' },
  { code: 'SAR', symbol: 'ر.س', flag: '🇸🇦', name: 'Saudi Riyal' },
  { code: 'AED', symbol: 'د.إ', flag: '🇦🇪', name: 'UAE Dirham' },
  { code: 'KWD', symbol: 'د.ك', flag: '🇰🇼', name: 'Kuwaiti Dinar' },
  { code: 'QAR', symbol: 'ر.ق', flag: '🇶🇦', name: 'Qatari Riyal' },
  { code: 'BHD', symbol: 'د.ب', flag: '🇧🇭', name: 'Bahraini Dinar' },
  { code: 'OMR', symbol: 'ر.ع', flag: '🇴🇲', name: 'Omani Rial' },
  { code: 'EGP', symbol: 'ج.م', flag: '🇪🇬', name: 'Egyptian Pound' },
];
